/*
 * The one message this tab has sent and not yet seen answered, kept across a
 * reload so its Retry resends the SAME clientMessageId and text. Per user, in
 * sessionStorage (this tab only, gone with it), and removed as soon as the
 * reply is DONE or the message can no longer be retried. Storage failures
 * (private mode, quota) only lose this convenience.
 */

const PREFIX = "lz.coach.outbox.v1:";
const CLIENT_MESSAGE_ID = /^[A-Za-z0-9_-]{8,64}$/;

function storage() {
  try {
    return typeof window !== "undefined" ? window.sessionStorage : null;
  } catch {
    return null;
  }
}

export function readOutbox(userId) {
  if (!userId) return null;
  try {
    const raw = storage()?.getItem(`${PREFIX}${userId}`);
    const value = raw ? JSON.parse(raw) : null;
    return value && CLIENT_MESSAGE_ID.test(value.clientMessageId) && typeof value.text === "string"
      ? { clientMessageId: value.clientMessageId, text: value.text, startedAt: value.startedAt || null }
      : null;
  } catch {
    return null;
  }
}

export function writeOutbox(userId, entry) {
  if (!userId) return;
  try {
    storage()?.setItem(`${PREFIX}${userId}`, JSON.stringify(entry));
  } catch {
    // best effort
  }
}

export function clearOutbox(userId, clientMessageId = null) {
  if (!userId) return;
  try {
    if (clientMessageId && readOutbox(userId)?.clientMessageId !== clientMessageId) return;
    storage()?.removeItem(`${PREFIX}${userId}`);
  } catch {
    // best effort
  }
}

// UUID v4 (contract §3), with a fallback where randomUUID is missing
// (older WebKit on plain http).
export function createClientMessageId(cryptoImpl = typeof crypto !== "undefined" ? crypto : null) {
  if (typeof cryptoImpl?.randomUUID === "function") return cryptoImpl.randomUUID();
  const bytes = new Uint8Array(16);
  if (typeof cryptoImpl?.getRandomValues === "function") cryptoImpl.getRandomValues(bytes);
  else for (let i = 0; i < 16; i += 1) bytes[i] = Math.floor(Math.random() * 256);
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;
  const hex = [...bytes].map((b) => b.toString(16).padStart(2, "0")).join("");
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
